// src/ga4.js
// Skicka ett GA4-event via gtag (laddas i public/index.html).
// Ogatat – gäller ALL trafik (till skillnad från Meta-pixeln).
export const trackGA4 = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};
